import React from 'react'
import Login from '~/views/Popup/views/Login'
import Spinner from '~/components/Spinner'

import userStore from '~/redux/user/store'
import { validateSubscriptionOfferCode, validateTransactionOfferCode, subscribeBySubscriptionOfferCode, subscribeByTransactionOfferCode } from '~/redux/user/subscription'
import { fetchModels } from '~/redux/models/helpers'
import connect from "~/tools/connect";

import './styles.scss'

class RedeemOffer extends React.Component {
  constructor(props) {
    super(props)
    const { metadataMap } = this.props.data || {}
    let localData = {
		redeemSection: JSON.parse(metadataMap.redeemSection),
      	authSection: JSON.parse(metadataMap.authSection),
		planDetails: JSON.parse(metadataMap.planDetails),
      	successSection: JSON.parse(metadataMap.successSection)
    }
    this.state = {
      metaData: [{
        title: localData.redeemSection.title,
        message: localData.redeemSection.description,
        cta: localData.redeemSection.cta,
      }, {
        title: localData.authSection.title,
        message: localData.authSection.description,
        guestMessage: localData.authSection.guestUserDescription,
      }, {
        title: localData.successSection.title,
        message: localData.successSection.description,
        cta: localData.successSection.cta
      }],
      planText: localData.planDetails,
      redirectInterval: null,
      authenticateInitiated: false,
      authenticationState: null,
      offerCode: null,
      processing: false,
      error: null,
      currentStep: 0,
      planDetails: null,
      planType: null,
    }

    this.processValidateOfferCode = this.processValidateOfferCode.bind(this)
    this.authenticateCallback = this.authenticateCallback.bind(this)
    this.initiateAuthentication = this.initiateAuthentication.bind(this)
    this.subscribeUser = this.subscribeUser.bind(this)
    this.redirectUser = this.redirectUser.bind(this)
  }

  async componentDidMount() {
    if(this.state.user && this.state.user.isSubscribed && this.state.redirectInterval === null){
      this.redirectUser()
    }
    this.setState({ model: await fetchModels() })
  }

  componentDidUpdate(){
    if(this.state.user && this.state.user.isSubscribed && !this.state.processing && this.state.currentStep < 2 && this.state.redirectInterval === null){
      this.redirectUser()
    }
  }

  redirectUser(){
    if(this.state.redirectInterval === null){
      this.setState({
        redirectInterval: 5
      })
      setInterval(() => {
        this.redirectUser()
      }, 1000)
    } else if(this.state.redirectInterval > 0){
      this.setState(prevState => {
        return {
          redirectInterval: prevState.redirectInterval - 1
        }
      })
    } else {
      window.location.href = '/'
      return false
    }
  }

  initiateAuthentication(type){
    let authenticationState = type === 'login' ? 'Logging In ...' : 'Signing Up ...'
    setTimeout(_ => { 
      this.setState({
        processing: true,
        authenticateInitiated: true,
        authenticationState: authenticationState,
      })
    })
  }

  authenticateCallback(result, message){
    if(result){
      this.subscribeUser()
    }else{
      this.setState({
        processing: false,
        authenticationState: null,
        authenticateInitiated: false,
      })
    }
  }

  async subscribeUser(){
    if (this.state.user && !this.state.user.isSubscribed) {
		this.setState({
			authenticationState: this.state.model.includes('SVOD') ? 'Subscribing ...' : 'Adding to your library.',
			processing: true,
		})
		// const subscriptionResponse = (this.state.planType === 'TRANSACTION') ? 
		const subscriptionResponse = (this.state.planType === 'SUBSCRIPTION') ? 
				await subscribeBySubscriptionOfferCode(this.state.offerCode) :
				await subscribeByTransactionOfferCode(this.state.offerCode)
		if(!subscriptionResponse.isError && subscriptionResponse.data.subscriptionStatus === 'COMPLETED'){
			this.setState({
				authenticationState: null,
				authenticateInitiated: false,
			})
			this.nextStep()
		}else{
			this.setState({
				processing: false,
				authenticationState: null,
				authenticateInitiated: false,
				error: subscriptionResponse.error || 'An unknown error occuredd.'
			})			
		}
    } else {
      this.redirectUser()
    }
  }

  processValidateOfferCode(evt){
    evt.preventDefault()
    let offerCode = this.offerCodeInput.value
    this.setState({
      processing: true,
      error: null,
      offerCode: offerCode
    }, async () => {
    	const validateSubscriptionResponse = await validateSubscriptionOfferCode(offerCode)
		if(!validateSubscriptionResponse.isError){
			return this.setState({
				planDetails: validateSubscriptionResponse.data,
				planType: 'SUBSCRIPTION'
			}, this.nextStep())
		}
    	const validateTransactionResponse = await validateTransactionOfferCode(offerCode)
		if(!validateTransactionResponse.isError){
			return this.setState({
				planDetails: validateTransactionResponse.data,
				planType: 'TRANSACTION'
			}, this.nextStep())
		}
		this.setState({
			error: validateTransactionResponse.error ?  validateTransactionResponse.error : validateSubscriptionResponse.error,
			processing: false,
		})
    })
  }

  nextStep(){
    this.setState(prevState => {
      return {
        currentStep: prevState.currentStep < 2 ? prevState.currentStep + 1 : 0,
        processing: false,
        error: null
      }
    })
  }

  prevStep(){
    this.setState(prevState => {
      return {
        currentStep: prevState.currentStep > 0 ? prevState.currentStep - 1 : 0,
        processing: false,
        error: null
      }
    })
  }

  render() {
    if(this.state.user && this.state.user.isSubscribed && this.state.currentStep < 2)
      return (
        <div className="redeem-offer-code-container centered">
          <div className='title'>
            You already have a valid subscription plan.
          </div>
          {
            this.state.redirectInterval !== null &&
            (
              <div className='message'>
                You will be redirected in {this.state.redirectInterval} seconds.
              </div>
            )
          }
        </div>
      )
    let message = (!this.state.user && this.state.metaData[this.state.currentStep].guestMessage) ? this.state.metaData[this.state.currentStep].guestMessage : this.state.metaData[this.state.currentStep].message
    return (
      <div className="redeem-offer-code-container centered">
        <div className='title'>
          {this.state.metaData[this.state.currentStep].title}
        </div>
        <div className='message'>
          {message}
        </div>
        {
          this.state.currentStep === 0 ?
          this.renderValidateSection() :
          this.state.currentStep === 1 ?
          this.renderAuthenticateSection() :
          this.renderSuccessSection()
        }
        {
          this.state.authenticationState !== null &&
          (
            <div className='overlay'>
              <div className="loading centered">
                <Spinner/>
                {this.state.authenticationState}
              </div>
            </div>
          )
        }
      </div>
    )
  }

  renderValidateSection(){
    return (
      <div className="validation-view-container">
        <form
          className="redeem-offer-code-view"
          onSubmit={evt => this.processValidateOfferCode(evt)}>
          <div>
            <div className="input-box">
              <input type="text" placeholder="ENTER CODE" ref={ i => { this.offerCodeInput = i} } defaultValue={this.state.offerCode} autoFocus />
            </div>
          </div>
          <div className={ `error-block collapsible ${ this.state.error ? '' : 'collapsed' }` }>
            { this.state.error || '' }
          </div>
          <div className="button-container">
            <input
              type="submit"
              className={`redeem-offer-code-button button fat cta right-section ${ this.state.processing ? 'disabled' : '' }`}
              value={
                this.state.processing ?
                  'Processing ...' :
                  'Redeem'
              } />
          </div>
        </form>
      </div>
    )
  }

  renderAuthenticateSection(){
    if(this.state.planDetails === null || this.state.planType === null)
      return

    let showLoginSection = !this.state.user ? true : this.state.authenticateInitiated ? true : this.state.user.isSubscribed ? true : false
    let planDuration = `${this.state.planDetails.renewalCyclePeriodMultiplier} ${this.state.planDetails.renewalCycleType}${this.state.planDetails.renewalCyclePeriodMultiplier > 1 ? 'S' : ''}`
    let titleTextLeft = this.state.planText.title.left.replace('{planDuration}', planDuration)
    let titleTextRight = this.state.planText.title.right.replace('{planDuration}', planDuration)
    let descriptionText = this.state.planText.description.replace('{planDuration}', planDuration)
    return (
      <div className="authenticate-view-container">
        <div className={`right-section ${showLoginSection ? 'float-right' : ''}`}>
          <div className="planbox site-background-color">
            <div className="header">
              {titleTextLeft} <span className="plan-duration">{titleTextRight}</span>
            </div>
            <div className="description">
              <p>
                {descriptionText}
              </p>
            </div>
          </div>
          <div className={ `error-block collapsible ${ this.state.error ? '' : 'collapsed' }` }>
            { this.state.error || '' }
          </div>
          {
            !showLoginSection &&
            (
              <div className="button-container">
                <input
                  type="button"
                  className={`redeem-offer-code-button button fat cta right-section ${ this.state.processing ? 'disabled' : '' }`}
                  onClick={_ => {
                    this.subscribeUser()
                  }}
                  value={
                    this.state.processing ?
                      'Processing ...' :
                      this.state.planText.cta
                  } />
              </div>
            )
          }
        </div>
        {
          showLoginSection &&
          (
            <div className="left-section float-left">
              <Login activeTab='signup' onInitiate={this.initiateAuthentication} onAuthenticate={this.authenticateCallback} user={this.state.user} />
            </div>
          )
        }
        <div className="clear"></div>
      </div>
    )
  }
  renderSuccessSection(){
    return (
      <div className='success-view-container'>
        <input
          type="button"
          className={`redeem-offer-code-button button fat cta`}
          onClick={_ => {
            window.location.href = this.state.model.includes('TVOD') ? '/user/library' : '/'
          }}
          value="Let's Go!" />
      </div>
    )
  }
}


connect(RedeemOffer, (state) => ({ user: state.user }), userStore)

export default RedeemOffer